import * as React from "react";
import { Checkbox, Radio, message } from "antd";

interface IPorps {
  questions: any[];
  id: any;
  target: any;
  confirm: any;
  hideVoteDialog: () => void;
}
interface IQuestions {
  maxNumber: number;
  max: boolean;
  question: string;
  plainOptions: any[];
  questionnaireId: number;
}

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;

export default class NormalComponent extends React.Component<IPorps, any> {
  // private  liveId: string;

  constructor(props: IPorps) {
    super(props);
    this.state = {
      max: false, // 单选多选 {true} 多选
      maxNumber: 1, // 最大选择数目
      question: "", // 投票题目
      plainOptions: [], // 选项
      voteSendSave: [], // 投票信息
      checkboxPlain: [], // checkbox 全部选项
      voteValue: [], // checkbox 选中选项
      targetValueId: "" // radio    选中Id
    };
  }

  public componentDidMount() {
    // this.liveId = window.location.pathname.replace(/.*v\/(.*)/, '$1')
    const questions: IQuestions[] = this.props.questions.map((e: any) => {
      const options = e.optionsOfQuestion.map((k: any) => {
        return {
          id: k.id,
          content: k.content
        };
      });
      return {
        maxNumber: e.maxNumberChoice,
        max: e.maxNumberChoice !== 1,
        question: e.question,
        plainOptions: options,
        questionnaireId: e.id
      };
    });

    const checkboxPlain = questions[0].plainOptions.map((e: any) => {
      return e.content;
    });

    this.setState({
      checkboxPlain,
      plainOptions: questions[0].plainOptions,
      question: questions[0].question,
      max: questions[0].max,
      maxNumber: questions[0].maxNumber,
      questionnaireId: questions[0].questionnaireId
    });
  }

  public voteSubmit = () => {
    const { confirm, target } = this.props;
    const { voteValue, questionnaireId } = this.state;
    if (voteValue.length === 0) {
      message.info("请选择答案后再提交");
      return;
    }

    const answers = voteValue.map((e: any) => {
      return {
        choiceQuestionId: questionnaireId,
        optionsOfQuestionId: e
      };
    });

    const Obj = {
      address: "",
      answers,
      email: "",
      ip: "",
      name: "",
      phone: "",
      questionnaireId: this.props.id
    };
    confirm(target, Obj);
  };

  public onCheckboxChange = (checkedValues: any) => {
    const { maxNumber } = this.state;
    if (checkedValues.length > maxNumber) {
      message.info(`最多选择${maxNumber}项目`);
      return;
    }
    this.setState({
      voteValue: checkedValues
    });
  };

  public onRadioChange = (e: any) => {
    this.setState({
      voteValue: [e.target.value]
    });
  };

  public onClose = () => {
    const { hideVoteDialog } = this.props;
    hideVoteDialog();
  };

  public render() {
    const { plainOptions, question, maxNumber, voteValue, max } = this.state;

    return (
      <div className="dialog__container">
        <div className="vote__question">
          {question}(
          {max ? (
            <span>
              最多选
              {maxNumber}项
            </span>
          ) : (
            <span>单选</span>
          )}
          )
        </div>
        {max ? (
          <CheckboxGroup value={voteValue} onChange={this.onCheckboxChange}>
            {plainOptions.map((e: any, i: number) => {
              return (
                <div key={i}>
                  <Checkbox value={e.id}>
                    {i + 1}、{e.content}
                  </Checkbox>
                </div>
              );
            })}
          </CheckboxGroup>
        ) : (
          <RadioGroup onChange={this.onRadioChange}>
            {plainOptions.map((e: any, i: number) => {
              return (
                <div key={i}>
                  <Radio value={e.id}>
                    {i + 1}、{e.content}
                  </Radio>
                </div>
              );
            })}
          </RadioGroup>
        )}

        <div className="vote__btn--container">
          <button className="vote__btn" onClick={this.onClose}>
            取消
          </button>

          <button className="vote__btn vote__affirm-btn" onClick={this.voteSubmit}>
            提交
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/vote/component/normal.tsx